import React from "react";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { useMenuState } from "@assets/contexts/MenuContext";

const settings = ["프로필", "로그아웃"];

const MainAppBar = ({ drawerWidth, onLogout, onHome, user }) => {
  const value = useMenuState();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (setting = "close") => {
    setAnchorElUser(null);
    if (setting === "로그아웃") {
      onLogout();
    } else if (setting === "프로필") {
      navigate("/profile", { replace: true });
    }
  };
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: {
          xs: `calc(100% - ${drawerWidth}px)`,
          sm: `calc(100% - ${drawerWidth}px)`,
          md: `calc(100% - ${drawerWidth}px)`,
          lg: `calc(100% - ${drawerWidth}px)`,
          xl: `calc(100% - ${drawerWidth}px)`,
        },
        backgroundColor: "background.default",
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Tooltip title="Profile settings">
            <Stack
              direction="row"
              spacing={2}
              onClick={handleOpenUserMenu}
              sx={{ cursor: "pointer", justifyContent: "flex-end" }}
            >
              <Avatar
                sx={{ width: 36, height: 36, bgcolor: "#EBEBEB" }}
              ></Avatar>
              <Typography
                variant="body"
                component="div"
                sx={{
                  color: "#686869",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {user && user.name}
              </Typography>
            </Stack>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) =>
              setting === "프로필" && value.user.ADMIN !== null ? (
                <MenuItem
                  sx={{ display: "none" }}
                  key={setting}
                  onClick={() => handleCloseUserMenu(setting)}
                >
                  <Typography textAlign="center" variant="body">
                    {setting}
                  </Typography>
                </MenuItem>
              ) : (
                <MenuItem
                  key={setting}
                  onClick={() => handleCloseUserMenu(setting)}
                >
                  <Typography textAlign="center" variant="body">
                    {setting}
                  </Typography>
                </MenuItem>
              )
            )}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainAppBar;
